// extracted by mini-css-extract-plugin
export var errorIcon = "_nz-1";
export var nameLogo = "_nz-0";